module.exports = __webpack_public_path__ + "static/media/gigi.07cdac31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadImg/gigi.jpg
// module id = 715
// module chunks = 0